import User from "../models/User" ;
import AuditRecord from "../models/AuditRecord" ;


  export default  class  AuditLogUtils {  public static loginedUser: User = null ;
 public constructor (  ) {
  }
  public static reacordTwilioNumberReleaseDeails ( numberValue : string ) : void {
 let record :AuditRecord=new AuditRecord();

record.setActionOwner(AuditLogUtils.loginedUser);

record.setAction('Number Release');

record.setActionDescription('Twilio Number Release: ' + numberValue);

record.save();
 }
  public static reacordTwilioNumberAssignDeails ( numberValue : string,user : User ) : void {
 let record :AuditRecord=new AuditRecord();

record.setActionOwner(AuditLogUtils.loginedUser);

record.setAction('Number Assign');

record.setActionDescription('Twilio Number Assign: ' + numberValue + ' to ' + user.firstName ?? '' + ' ' + user.lastName ?? '');

record.save();
 }
  public static reacordTwilioNumberUnAssignDeails ( numberValue : string,user : User ) : void {
 let record :AuditRecord=new AuditRecord();

record.setActionOwner(AuditLogUtils.loginedUser);

record.setAction('Number UnAssign');

record.setActionDescription('Twilio Number UnAssign: ' + numberValue + ' from ' + user.firstName ?? '' + ' ' + user.lastName ?? '');

record.save();
 }
 }